<template>
	<v-fade-transition mode="out-in">
		<v-container key="1_AlertSemDadosParaEtapa" v-if="!loading" fluid
		             class="d-flex justify-center align-center align-content-center fill-height rounded"
		             style="background-color: #f6f6f6">
<!-- ICONES	-->
			<div class="p-absolute z-2" style="margin-left: 82px; margin-bottom: 14px;">
				<v-icon size="72" color="#FFCACA" style="transform: rotateZ(36deg)">mdi-pig</v-icon>
			</div>
			<div class="p-absolute z-3">
				<v-icon size="82" color="#7B9596">fas fa-exclamation-triangle</v-icon>
			</div>
			<div class="p-absolute z-3 question_animado" style="margin-left: 38px; margin-bottom: 76px;">
				<v-icon size="28" color="#7B9596">fas fa-question</v-icon>
			</div>

<!-- DESCRICAO -->
			<v-row class="d-flex justify-center titulo-alert">
				{{ titulo }}
			</v-row>
			<v-row class="d-flex justify-center subtitulo-alert">
				{{ subTitulo }}
			</v-row>

<!-- LOADER -->
		</v-container>
		<v-container key="2_AlertSemDadosParaEtapa" v-else fluid
		             class="d-flex justify-center align-center align-content-center fill-height rounded">
			<v-progress-circular indeterminate color="primary" />
		</v-container>
	</v-fade-transition>

</template>

<script>
export default {
	name: "AlertSemDadosParaEtapa",
	data: () => ({}),
	props: {
		titulo: {
			type: String,
			default: 'Sem resultados'
		},
		subTitulo: {
			type: String,
			default: ''
		},
		loading: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped>
@keyframes changewidth {
    from {
        transform: scale(1);
    }

    to {
        transform: scale(0.5);
    }
}

.question_animado {
    animation-duration: 0.6s;
    animation-name: changewidth;
    animation-iteration-count: infinite;
    animation-direction: alternate;
}

.titulo-alert {
    margin-top: 140px;
    font: bold normal normal 24px/28px Roboto;
    letter-spacing: 0;
    color: #7B9596;
}

.subtitulo-alert {
    font: normal normal normal 10px/13px Roboto;
    letter-spacing: 0;
    color: #7B9596;
}

</style>